import { UseFormGetValues, UseFormSetValue } from 'react-hook-form';

import { QuickQuoteInputs } from '../../types';
import {
  ParsedStopAddress,
  applyParsedStopAddressToQuoteFormStop,
} from '../../utils/parseStopAddressFromLocation';

const parsedStopFieldSetOptions = {
  shouldDirty: true,
  shouldValidate: false,
} as const;

/** Writes regex-parsed stop address fields on the quick-quote form (Tai LTL). */
export function syncParsedStopAddressToForm(
  stopIndex: number,
  parsed: ParsedStopAddress,
  getValues: UseFormGetValues<QuickQuoteInputs>,
  setValue: UseFormSetValue<QuickQuoteInputs>
): void {
  const stop = getValues(`stops.${stopIndex}`);
  const updated = applyParsedStopAddressToQuoteFormStop(stop, parsed);

  setValue(
    `stops.${stopIndex}.addressLine1`,
    updated.addressLine1 ?? '',
    parsedStopFieldSetOptions
  );
  setValue(
    `stops.${stopIndex}.addressLine2`,
    updated.addressLine2 ?? '',
    parsedStopFieldSetOptions
  );
  setValue(`stops.${stopIndex}.city`, updated.city, parsedStopFieldSetOptions);
  setValue(
    `stops.${stopIndex}.state`,
    updated.state,
    parsedStopFieldSetOptions
  );
  setValue(`stops.${stopIndex}.zip`, updated.zip, parsedStopFieldSetOptions);
  setValue(
    `stops.${stopIndex}.country`,
    updated.country,
    parsedStopFieldSetOptions
  );
}
